<div>
    <div class="ap-display-block ap-margin-bottom-4 ap-flex-row ap-justify-content-center ap-align-items-center">
        <h2>{{ 'mijn.login.application.NoAvailableTokensModal.title' | apContent }}</h2>
    </div>
    <ap-notification status="error">
        <div class="ap-display-block ap-margin-bottom-4 ap-flex-column ap-justify-content-start ap-align-items-center ap-flex-gap-24">
            <p><ap-content [key]="'mijn.login.application.NoAvailableTokensModal.description'"></ap-content></p>
            <h3>{{ 'mijn.login.application.NoAvailableTokensModal.options' | apContent }}</h3>
            <ul>
                <li><ap-content [key]="'mijn.login.application.NoAvailableTokensModal.option1'"></ap-content></li>
                <li><ap-content [key]="'mijn.login.application.NoAvailableTokensModal.option2'"></ap-content></li>
            </ul>
        </div>
    </ap-notification>
</div>
